
import { Component, Vue, Prop } from "vue-property-decorator";
import { Posting } from "@/generated/graphql";
import BadgeColor from "@/entities/BadgeColor";
import GetRelativeRouteNameMixin from "@/mixins/route/GetRelativeRouteNameMixin.vue";
import { mixins } from "vue-class-component";
import ItemChipsData from "@/entities/ItemChipsData";
import Badge from "@/components/common/Badge.vue";
import EditPenIcon from "@/components/icons/EditIcon.vue";
import EyeOffIcon from "@/components/icons/EyeOffIcon.vue";
  import UPDATE_POSTING_ACTIVE_STATUS from "@/apollo/jobboard/UpdatePostingActiveStatus.gql";
import EyeIcon from "@/components/icons/EyeIcon.vue";
  import Spinner from '@/components/common/Spinner.vue';

@Component({
  components: {
    EditPenIcon,
    Badge,
    EyeOffIcon,
    EyeIcon,
    Spinner
  }
})
export default class PostingCardHeader extends  mixins(GetRelativeRouteNameMixin) {
  @Prop({ type: Object, required: true }) readonly posting!: Posting;
  @Prop({ type: Array, required: false, default: 0 }) readonly applications!: []  | ItemChipsData[];
  @Prop({ type: Boolean, default: false }) readonly canEdit!: boolean;

    processing: boolean = false;


  get badgeData(): { value: string, color: string, class?: string } {
    if (!this.posting.active) {
      return {
        value: "Inactive",
        color: BadgeColor.WARNING,
      }
    }
    if (this.posting.active) {
      return {
        value: "Active",
        color: BadgeColor.SUCCESS,
        class: 'text-badge'
      }
    }
    if (!this.applications.length) {
      return {
        value: "No applicants yet",
        color: BadgeColor.INFO,
      }
    }
    const applicants = this.applications.length == 1 ? "applicant" : "applicants";
    return {
      value: `${this.applications.length} ${applicants}`,
      color: BadgeColor.SUCCESS,
    }
  }

  
  onEdit() {
  this.$emit('post:edit', this.posting)
  }
      get activeButtonText(): string {
      return this.posting.active ? 'Deactivate' : 'Activate';
    }

    async handleToggleActiveness(): Promise<void> {
      this.processing = true;
this.$emit('post:toggleStart', this.posting)
       this.$apollo.mutate({
        mutation: UPDATE_POSTING_ACTIVE_STATUS,
        variables: {
          id: this.posting.id,
          set: {active: !this.posting.active},
        },
      }).then(d => {
        this.$emit('post:toggleSuccess', this.posting)
        
      }).catch(e => {
        this.$emit('post:toggleError', this.posting)
        
      }).finally(() => {
        this.$emit('post:toggleEnd', this.posting)
        this.processing = false;
      });

    }
}
